export default __webpack_public_path__ + "static/media/file.73c3d817.png";